import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

export const ApplicationStepWeight: React.SFC<LifeInsuranceApplicationProps> = (props) => {
  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(true)
  }, [])

  return (
    <Wrapper {...props}>
      <StepTitle>How much do you weigh?</StepTitle>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.WeightInPounds}
        onEnter={props.onContinue}
        styles={styles.formRow}
      />
    </Wrapper>
  )
}
